
import React from 'react'
import AdminPage from './AdminPage'
import Menu from './Menu'

function AdminMain() {
  return (
    <div>
         <Menu/>
    <AdminPage/>
    {/* <Hotel/> */}
    </div>
  )
}

export default AdminMain